"use strict";
/**
 * @packageDocumentation
 * @module DelegationBaseNode
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchChildren = exports.getChildIds = exports.getAttestationHashes = void 0;
const utils_1 = require("@kiltprotocol/utils");
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
function decodeDelegatedAttestations(queryResult) {
    utils_1.DecoderUtils.assertCodecIsType(queryResult, ['Vec<Hash>']);
    return queryResult.map((hash) => hash.toString());
}
/**
 * @param id
 * @internal
 */
async function getAttestationHashes(id) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const encodedHashes = await blockchain.api.query.attestation.delegatedAttestations(id);
    return decodeDelegatedAttestations(encodedHashes);
}
exports.getAttestationHashes = getAttestationHashes;
/**
 * @param id
 * @internal
 */
async function getChildIds(id) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const childIds = await blockchain.api.query.delegation.children(id);
    utils_1.DecoderUtils.assertCodecIsType(childIds, ['Vec<DelegationNodeId>']);
    return childIds.map((hash) => hash.toString());
}
exports.getChildIds = getChildIds;
/**
 * @param childIds
 * @internal
 */
async function fetchChildren(childIds) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const val = await Promise.all(childIds.map(async (childId) => {
        const queryResult = await blockchain.api.query.delegation.delegations(childId);
        return {
            id: childId,
            codec: queryResult,
        };
    }));
    return val;
}
exports.fetchChildren = fetchChildren;
